import { createContext, useContext, useEffect, useState } from "react";
import { refreshToken } from "../services/authService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    try {
      const storedUser = localStorage.getItem("user");
      const token = localStorage.getItem("token");

      if (storedUser && token) {
        setUser(JSON.parse(storedUser));
      }
    } catch (err) {
      console.error("Failed to load user info", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTokenRefresh = async () => {
    const rToken = localStorage.getItem("refreshToken");
    if (!rToken) return;

    console.log("🕒 Initiating scheduled token refresh...");
    try {
      const res = await refreshToken(rToken);
      if (res && res.success && res.data) {
        const { access_token, refresh_token } = res.data;
        localStorage.setItem("token", access_token);
        localStorage.setItem("refreshToken", refresh_token);
        console.log("✅ Token refreshed successfully");
      }
    } catch (err) {
      console.error("❌ Token refresh failed", err);
      // Optional: If refresh fails (e.g. refresh token expired), log out user
      // logout(); 
    }
  };


  return (
    <AuthContext.Provider value={{ user, loading, handleTokenRefresh }}>
      {children}
    </AuthContext.Provider>
  );
};

/* ✅ EXPORT HOOK DIRECTLY */
export const useUser = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useUser must be used inside AuthProvider");
  }
  return context;
};
